import { useEffect, useState } from "react";
import { API } from "../lib/api";

function EmbeddedForm({ formId }) {
  const [form, setForm] = useState(null);
  const [ans, setAns] = useState({});
  const [done, setDone] = useState("");
  useEffect(() => { fetch(`${API}/public/forms/${formId}`).then((r) => r.ok && r.json()).then(setForm); }, [formId]);
  if (!form) return null;
  if (done) return <div className="p-4 rounded bg-emerald-50 text-emerald-800 text-sm">{done}</div>;
  const submit = async (e) => {
    e.preventDefault();
    const r = await fetch(`${API}/public/forms/${formId}/submit`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ answers: ans, consent: true }) });
    const d = await r.json();
    setDone(r.ok ? d.message : d.detail);
  };
  return (
    <form onSubmit={submit} className="space-y-3 max-w-md mx-auto text-left">
      {form.fields.map((f) => (
        <input key={f.key} required={f.required} type={f.type === "textarea" ? "text" : f.type} placeholder={f.label}
          className="w-full rounded border border-slate-300 px-3 py-2 text-slate-900" onChange={(e) => setAns({ ...ans, [f.key]: e.target.value })} />
      ))}
      <button className="w-full rounded bg-teal-600 text-white py-2 font-semibold">{form.submit_text || "Submit"}</button>
    </form>
  );
}

export function Block({ b }) {
  if (b.type === "hero")
    return (
      <section className="relative py-20 px-6 text-center text-white" style={{ background: b.bg || "#0B0F17" }}>
        {b.image && <img src={b.image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />}
        <div className="relative max-w-3xl mx-auto">
          <h1 className="text-4xl sm:text-5xl font-extrabold">{b.heading}</h1>
          {b.text && <p className="mt-4 text-lg opacity-80">{b.text}</p>}
          {b.button_text && <a href={b.button_link || "#"} className="inline-block mt-6 rounded bg-teal-600 px-6 py-3 font-semibold">{b.button_text}</a>}
        </div>
      </section>
    );
  if (b.type === "text")
    return <section className="py-12 px-6 max-w-3xl mx-auto text-slate-800">{b.heading && <h2 className="text-2xl font-bold mb-3">{b.heading}</h2>}<p className="whitespace-pre-wrap leading-relaxed">{b.text}</p></section>;
  if (b.type === "image")
    return <section className="py-8 px-6 max-w-4xl mx-auto">{b.image && <img src={b.image} alt={b.heading || ""} className="w-full rounded" />}</section>;
  if (b.type === "cta")
    return (
      <section className="py-14 px-6 text-center bg-amber-50 text-slate-900">
        <h2 className="text-3xl font-bold">{b.heading}</h2>{b.text && <p className="mt-2">{b.text}</p>}
        {b.button_text && <a href={b.button_link || "#"} className="inline-block mt-5 rounded bg-slate-900 text-white px-6 py-3 font-semibold">{b.button_text}</a>}
      </section>
    );
  if (b.type === "form")
    return <section className="py-12 px-6 bg-slate-50 text-slate-900 text-center">{b.heading && <h2 className="text-2xl font-bold mb-5">{b.heading}</h2>}{b.form_id && <EmbeddedForm formId={b.form_id} />}</section>;
  return null;
}

export function FunnelRenderer({ step }) {
  return <div className="bg-white min-h-full">{(step?.blocks || []).map((b, i) => <Block key={i} b={b} />)}</div>;
}
